/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, prettyHour } from '../utils/util';
import './Leaderboard.css';
import Wrapper from './Wrapper';
import LeaderboardStats from './partials/LeaderboardStats';
import {
  getLeaderboard
} from '../actions';



class Leaderboard extends OzComponent {

  static need = [
    ['leaderboard', getLeaderboard],
  ];

  state = {};
  
  renderLeaderboard() {
    let lb = this.props.leaderboard;
    if (!lb) return;
    return (
      <LeaderboardStats leaderboard={lb} topN={10} />
    );
  }

  render() {
    return (
      <Wrapper className="Leaderboard" title="Leaderboard">
        {this.renderLeaderboard()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    leaderboard: state.get.leaderboard,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Leaderboard);



/** WEBPACK FOOTER **
 ** ./src/components/Leaderboard.js
 **/